"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RtcConnection_1 = __importDefault(require("./RtcConnection"));
const RtcConnectionsStore_1 = __importDefault(require("./RtcConnectionsStore"));
const RtcMessageReceiver_1 = __importDefault(require("./RtcMessageReceiver"));
class RtcConnectionFactory {
    constructor() {
        this.createConfig = () => {
            const iceServers = [{
                    urls: [
                        "stun:stun.l.google.com:19302"
                    ]
                }];
            return {
                iceServers
            };
        };
        this.config = this.createConfig();
    }
    createNew(user) {
        return new RtcConnection_1.default(user, this.config, m => RtcMessageReceiver_1.default.handleMessage(user, m), () => RtcConnectionsStore_1.default.remove(user));
    }
}
const factory = new RtcConnectionFactory();
exports.default = factory;
